import { values } from './enums'

const _enum = {
  Idle: 0,
  Generating: 1,
  CheckingRulesRunning: 2,
  ExportGenerating: 3,
  DataSaving: 4,
  StateUpdating: 5,
  DataImporting: 6,
  Signing: 7
}

export const ReportGroupProcessState = {
  enumName: 'ReportGroupProcessState',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/reportGroupProcessState.js